export default __webpack_public_path__ + "5d6f26579d141f7182de2449fb1ad822.png";